<script setup lang="ts">
import { reactive, ref } from "vue";
import { maxDotNumber, clamp } from "@zyzgroup/core-common";
import {
  RingIndicatorShapeCombo,
  createRunCycleInMaxRate
} from "@zyzgroup/core-web";
import Box from "../base/Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    percent?: number;
    lineWidth?: number;
    bgColor?: string;
    startColor?: string;
    endColor?: string;
    half?: boolean;
  }>(),
  {
    percent: 0,
    lineWidth: 12,
    bgColor: "#B3C6E7",
    startColor: "#5A82F0",
    endColor: "#66B3FF",
    half: false // 半圆 或 全圆
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

let currentPercent = ref(0);
const getPercent = createRunCycleInMaxRate(() => {
  const percent = clamp(Math.floor(props.percent), 0, 100);
  if (currentPercent.value < percent) {
    currentPercent.value = Math.min(currentPercent.value + 1, percent);
  } else if (currentPercent.value > percent) {
    currentPercent.value = Math.max(currentPercent.value - 1, percent);
  }
  return maxDotNumber(currentPercent.value / 100, 2);
}, 20);

const shapes = reactive([]);
let ringIndicator;
function start(box) {
  if (ringIndicator) {
    return;
  }
  ringIndicator = new RingIndicatorShapeCombo({
    half: props.half,
    width: box.rect.width,
    height: box.rect.height,
    lineWidth: props.lineWidth,
    bgColor: props.bgColor,
    startColor: props.startColor,
    endColor: props.endColor
  });
  shapes.push(ringIndicator);
}

function frame() {
  ringIndicator?.setPercent(getPercent());
}

defineExpose({});
</script>

<template>
  <div class="ring-indicator">
    <Box
      type="canvas"
      :shapes="shapes"
      :loop="true"
      @start="start"
      @frame="frame"
    ></Box>
    <div
      :class="{
        'ring-text': true,
        'ring-text-full': !props.half,
        'ring-text-half': props.half
      }"
    >
      <span>{{ currentPercent }}</span>
      <span>%</span>
    </div>
  </div>
</template>

<style scoped>
.ring-indicator {
  position: relative;
  width: 100%;
  height: 100%;
}
.ring-text-full {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-family: D-DINCondensed-number;
  color: #333333;
  text-indent: 1em;
}
.ring-text-half {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: D-DINCondensed-number;
  color: #333333;
  padding-bottom: 20px;
  text-indent: 1em;
}
.ring-text > span:nth-child(1) {
  font-size: 64px;
}
.ring-text > span:nth-child(2) {
  font-size: 20px;
}
</style>
